"use strict";

var _classCallCheck = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\staff-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\staff-app\\node_modules\\@babel\\runtime/helpers/createClass");

var _possibleConstructorReturn = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\staff-app\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\staff-app\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _inherits = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\staff-app\\node_modules\\@babel\\runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var paho_mqtt_1 = require("../../clients/paho-mqtt");

var pb_1 = require("./pb");

var ExtendedBotMessage =
/*#__PURE__*/
function (_pb_1$BotMessage) {
  _inherits(ExtendedBotMessage, _pb_1$BotMessage);

  function ExtendedBotMessage(properties) {
    var _this;

    _classCallCheck(this, ExtendedBotMessage);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ExtendedBotMessage).call(this, properties));
    _this.type = ExtendedBotMessage.type;
    return _this;
  }

  _createClass(ExtendedBotMessage, [{
    key: "toMQTT",
    value: function toMQTT() {
      var topic = "".concat(this.property).concat(ExtendedBotMessage.context, "/").concat(this.gid || this.sfid);
      var mqttMessage = new paho_mqtt_1.Message(pb_1.BotMessage.encode(this).finish());
      mqttMessage.destinationName = topic;
      mqttMessage.qos = 1;
      return mqttMessage;
    }
  }], [{
    key: "fromMQTT",
    value: function fromMQTT(mqttMessage) {
      return new ExtendedBotMessage(pb_1.BotMessage.decode(mqttMessage.payloadBytes));
    }
  }]);

  return ExtendedBotMessage;
}(pb_1.BotMessage);

ExtendedBotMessage.type = "BotMessage";
ExtendedBotMessage.context = "/bot-chat";
exports.BotMessage = ExtendedBotMessage;